<div class="rule-container mt-half">
  <div class="d-flex justify-content-between">
    <span class="font-weight-bold mb-1">{{
      create
        ? ('WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_CREATE' | translate)
        : readonly
          ? ('WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_DETAIL' | translate)
          : ('WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_MODIFY' | translate)
     }}</span>
    <a class="btn-setting cursor-pointer" (click)="deleteRule.emit()" *ngIf="!create && !readonly"
       title="{{'COMMON_BUTTON_DELETE' | translate}}"><i class="icomoon icomoon-trash"></i></a>
  </div>
  <form class="form-horizontal bordered-row" (ngSubmit)="f.form.valid && save()" #f="ngForm" novalidate>
    <p class="w-100 m-0">{{getName()}}</p>
    <div *ngIf="operatorRequired">
      <label class="search-label">{{'WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_OPERATOR' | translate}}</label>
      <div class="row m-0">
        <button type="button" class="btn col mr-half"
                [class.btn-primary-applion-green-gray]="model.operator !== RuleOperator.AND"
                [class.btn-secondary-applion-green-gray]="model.operator === RuleOperator.AND"
                (click)="!readonly && setOperator(RuleOperator.AND)">
          {{'WORKFLOW_TRANSITION_RULE_OPERATOR_AND' | translate}}
        </button>
        <button type="button" class="btn col"
                [class.btn-primary-applion-green-gray]="model.operator !== RuleOperator.OR"
                [class.btn-secondary-applion-green-gray]="model.operator === RuleOperator.OR"
                (click)=" !readonly && setOperator(RuleOperator.OR)">
          {{'WORKFLOW_TRANSITION_RULE_OPERATOR_OR' | translate}}
        </button>
      </div>
    </div>
    <div [ngClass]="{ 'has-danger': f.submitted && !taskRuleType.valid}">
      <label class="search-label form-control-label">{{'WORKFLOW_EDIT_TRANSITION_TASK_RULE_TYPE' | translate}}</label>
      <angular2-multiselect [data]="types"
                            [settings]="dropdownSettingsForCommand"
                            class="form-control"
                            id="taskRuleType"
                            name="taskRuleType"
                            #taskRuleType="ngModel"
                            [(ngModel)]="model.type"
                            (ngModelChange)="onTypeChanged()"
                            required
                            validateEnabledItems
                            [readonly]="readonly"
                            [readonlyBorderEnabled]="true">
      </angular2-multiselect>
      <div class="form-control-feedback" *ngIf="f.submitted && !taskRuleType.valid && taskRuleType.errors['required']">
        {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
      </div>
      <div class="form-control-feedback" *ngIf="f.submitted && !taskRuleType.valid && taskRuleType.errors['hasDisabledItem']">
        {{'COMMON_VALIDATION_MESSAGE_DISABLED' | translate}}
      </div>
    </div>
    <div [ngClass]="{ 'has-danger': f.submitted && !command.valid}">
      <label class="search-label form-control-label">{{'WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_COMMAND' | translate}}</label>
      <angular2-multiselect [data]="commands"
                            [settings]="dropdownSettingsForCommand"
                            class="form-control"
                            id="command"
                            name="command"
                            #command="ngModel"
                            [(ngModel)]="model.command"
                            required
                            [readonly]="readonly"
                            [readonlyBorderEnabled]="true">
      </angular2-multiselect>
      <div class="form-control-feedback" *ngIf="f.submitted && !command.valid">
        {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
      </div>
    </div>
    <div *ngIf="model.getType() === TaskRuleType.ASSIGNEE_USER"
         [ngClass]="{ 'has-danger': f.submitted && !userValue.valid}">
      <label class="search-label form-control-label">
        {{'WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_VALUE' | translate}}
      </label>
      <angular2-multiselect [data]="users"
                            [settings]="dropdownSettingsForLists"
                            class="form-control"
                            id="userValue"
                            name="userValue"
                            #userValue="ngModel"
                            (onRemoteSearch)="loadUsers($event.target.value)"
                            [(ngModel)]="model.userValue"
                            [required]="model.type === TaskRuleType.ASSIGNEE_USER"
                            [readonly]="readonly"
                            [readonlyBorderEnabled]="true">
      </angular2-multiselect>
      <div class="form-control-feedback" *ngIf="f.submitted && !userValue.valid">
        {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
      </div>
    </div>
    <div *ngIf="model.getType() === TaskRuleType.ASSIGNEE_USER_GROUP || model.getType() === TaskRuleType.ASSIGNEE_USER_USER_GROUP"
         [ngClass]="{ 'has-danger': f.submitted && !userGroupValue.valid}">
      <label class="search-label form-control-label">
        {{'WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_VALUE' | translate}}
      </label>
      <angular2-multiselect [data]="userGroups"
                            [settings]="dropdownSettingsForLists"
                            class="form-control"
                            id="userGroupValue"
                            name="userGroupValue"
                            #userGroupValue="ngModel"
                            (onRemoteSearch)="loadGroups($event.target.value)"
                            [(ngModel)]="model.userGroupValue"
                            [required]="model.getType() === TaskRuleType.ASSIGNEE_USER_GROUP || model.getType() === TaskRuleType.ASSIGNEE_USER_USER_GROUP"
                            [readonly]="readonly"
                            [readonlyBorderEnabled]="true">
      </angular2-multiselect>
      <div class="form-control-feedback" *ngIf="f.submitted && !userGroupValue.valid">
        {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
      </div>
    </div>
    <div *ngIf="model.getType() === TaskRuleType.CUSTOMER_TYPE"
         [ngClass]="{ 'has-danger': f.submitted && !customerValue.valid}">
      <label class="search-label form-control-label">
        {{'WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_VALUE' | translate}}
      </label>
      <angular2-multiselect [data]="customers"
                            [settings]="dropdownSettingsForLists"
                            class="form-control"
                            id="customerValue"
                            name="customerValue"
                            #customerValue="ngModel"
                            (onRemoteSearch)="loadCustomers($event.target.value)"
                            [(ngModel)]="model.customerValue"
                            [required]="model.getType() === TaskRuleType.CUSTOMER_TYPE"
                            [readonly]="readonly"
                            [readonlyBorderEnabled]="true">
      </angular2-multiselect>
      <div class="form-control-feedback" *ngIf="f.submitted && !customerValue.valid">
        {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
      </div>
    </div>
    <div *ngIf="model.getType() === TaskRuleType.IMPORTANCE"
         [ngClass]="{ 'has-danger': f.submitted && !importanceValue.valid}">
      <label class="search-label form-control-label">
        {{'WORKFLOW_EDIT_TRANSITION_FORM_FIELD_RULE_VALUE' | translate}}
      </label>
      <angular2-multiselect [data]="importances"
                            [settings]="dropdownSettingsForImportance"
                            class="form-control"
                            id="importanceValue"
                            name="importanceValue"
                            #importanceValue="ngModel"
                            [(ngModel)]="model.importanceValue"
                            [required]="model.getType() === TaskRuleType.IMPORTANCE"
                            [readonly]="readonly"
                            [readonlyBorderEnabled]="true">
      </angular2-multiselect>
      <div class="form-control-feedback" *ngIf="f.submitted && !importanceValue.valid">
        {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
      </div>
    </div>

    <button type="button" class="btn w-100 btn-primary-applion-green-gray mt-1" *ngIf="create"
            (click)="createSubmitted.emit(false)">
      {{'COMMON_BUTTON_CANCEL' | translate}}
    </button>
    <button type="submit" class="btn w-100 btn-secondary-applion-green-gray mt-half" *ngIf="!readonly">
      {{'COMMON_BUTTON_SAVE' | translate}}
    </button>
  </form>
</div>
